import React from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react-lite';
import { useRootStore } from '../../App';
import { Flex } from '../atoms';
import { ChatHeaderImage } from '../molecules/ChatHeaderImage';
import { ChatHeaderDescription } from '../molecules/ChatHeaderDescription';
import { ChatHeaderRecipient } from '../molecules/ChatHeaderRecipient';

const StyledDiv = styled.div`
  ${(props: { isWide: boolean }) =>
    props.isWide
      ? `overflow: hidden;
      padding-top: 8px;`
      : `background: #ffffff;
      box-sizing: border-box;
      display: block;
      position: fixed;
      position: sticky;
      position: -webkit-sticky;
      top: 0px !important;
      width: 100%;
      z-index: 2;`}
`;

const StyledFlexDiv = styled(Flex)`
  ${(props: { isWide: boolean }) =>
    props.isWide ? '' : 'padding: 15px 16px 0px;'}
`;

interface Props {
  iconImageUrl: string;
}

export const ChatHeader = observer((props: Props) => {
  const { iconImageUrl } = props;
  const root = useRootStore();
  const { isWide } = root.layoutStore;
  const { headerInfoDivRef } = root.inquiryPageStore;
  const { activeInquiry } = root.inquiryStore;
  const { targetDetailForView } = root.partnerStore!; // FIXME remove "!"
  const { recipients } = root.userStore;
  const { getInquiryCategory } = root.faqStore;

  // multiple recipients are not supported
  const recipient = activeInquiry
    ? activeInquiry.recipients && activeInquiry.recipients[0]
    : Array.from(recipients.values())[0];

  const chatHeaderDescription = (
    <ChatHeaderDescription
      inquiryCategoryName={
        activeInquiry ? getInquiryCategory(activeInquiry.inquiryCategory) : ''
      }
      targetDetail={targetDetailForView}
      isWide={isWide}
    />
  );

  return (
    <>
      <StyledDiv isWide={isWide} ref={headerInfoDivRef}>
        <StyledFlexDiv isWide={isWide} middle>
          <React.Fragment key={`chat-header-fragment}`}>
            <ChatHeaderImage
              key={`chat-header-image}`}
              image={iconImageUrl}
              isWide={isWide}
            />
            {/* insert div here to show children components vertically */}
            <div style={{ width: '100%' }}>
              <ChatHeaderRecipient
                key={`chat-header-description}`}
                facilityName={recipient.userName || '-'}
                isWide={isWide}
              />
              {isWide && chatHeaderDescription}
            </div>
          </React.Fragment>
        </StyledFlexDiv>
        {isWide || chatHeaderDescription}
      </StyledDiv>
    </>
  );
});
